import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { useState } from "react";
import { useOffers } from "@hooks/useOffers";
import { IOffer } from "./ICart";
import { CartOfferListDesktop } from "./CartOfferListDesktop";
import { CartOfferListMobile } from "./CartOfferListMobile";

interface IParams {
    updateUserCart(offerUpdated: IOffer): void;
}

export const CartOfferList = ({ updateUserCart }: IParams) => {
    const [isMobile] = useState(window.innerWidth <= 768);

    const { arrow, offerList, offerListState, getOfferList } = useOffers();

    return (
        <HandleErrorAndLoading
            error={offerListState.error}
            isLoading={offerListState.isLoading}
            retryFetch={getOfferList}
        >
            {isMobile && (
                <CartOfferListMobile
                    arrowStep={arrow.arrowStep}
                    carouselItemCount={1}
                    handleBack={arrow.handleBack}
                    handleNext={arrow.handleNext}
                    handleOfferClick={updateUserCart}
                    handleStepChange={arrow.setArrowStep}
                    offerList={offerList}
                />
            )}
            {!isMobile && (
                <CartOfferListDesktop
                    arrowStep={arrow.arrowStep}
                    carouselItemCount={2}
                    handleBack={arrow.handleBack}
                    handleNext={arrow.handleNext}
                    handleOfferClick={updateUserCart}
                    offerList={offerList}
                />
            )}
        </HandleErrorAndLoading>
    );
};
